type TranslationType = "lat-cir" | "cir-lat";

export interface ILatinObject {
  [key: string]: string | ILatinObject;
}

export interface IKeyMap {
  [key: string]: string;
}

export const LATIN_CYRILIC_MAP_UPPERCASE: IKeyMap = {
  A: "А",
  B: "Б",
  C: "Ц",
  D: "Д",
  E: "Е",
  F: "Ф",
  G: "Г",
  H: "Х",
  I: "И",
  J: "Ј",
  K: "К",
  L: "Л",
  M: "М",
  N: "Н",
  O: "О",
  P: "П",
  R: "Р",
  S: "С",
  T: "Т",
  U: "У",
  V: "В",
  Z: "З",
  Č: "Ч",
  Ć: "Ћ",
  Đ: "Ђ",
  Ž: "Ж",
  Š: "Ш",

  // special cases

  Nj: "Њ",
  NJ: "Њ",
  LJ: "Љ",
  Lj: "Љ",
  DŽ: "Џ",
  Dž: "Џ",
};
export const CYRILIC_LATIN_MAP_UPPERCASE: IKeyMap = {
  А: "A",
  Б: "B",
  Ц: "C",
  Д: "D",
  Е: "E",
  Ф: "F",
  Г: "G",
  Х: "H",
  И: "I",
  Ј: "J",
  К: "K",
  Л: "L",
  М: "M",
  Н: "N",
  О: "O",
  П: "P",
  Р: "R",
  С: "S",
  Т: "T",
  У: "U",
  В: "V",
  З: "Z",
  Ч: "Č",
  Ћ: "Ć",
  Ђ: "Đ",
  Ж: "Ž",
  Ш: "Š",

  // special cases

  Њ: "Nj",
  Љ: "Lj",
  Џ: "Dž",
};
export const CYRILIC_LATIN_MAP_LOWERCASE: IKeyMap = {
  а: "a",
  б: "b",
  ц: "c",
  д: "d",
  е: "e",
  ф: "f",
  г: "g",
  х: "h",
  и: "i",
  ј: "j",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  в: "v",
  з: "z",
  ч: "č",
  ћ: "ć",
  ђ: "đ",
  ж: "ž",
  ш: "š",

  // special cases

  њ: "nj",
  љ: "lj",
  џ: "dž",
};

export const LATIN_CYRILIC_MAP_LOWERCASE: IKeyMap = {
  a: "а",
  b: "б",
  c: "ц",
  d: "д",
  e: "е",
  f: "ф",
  g: "г",
  h: "х",
  i: "и",
  j: "ј",
  k: "к",
  l: "л",
  m: "м",
  n: "н",
  o: "о",
  p: "п",
  r: "р",
  s: "с",
  t: "т",
  u: "у",
  v: "в",
  z: "з",
  č: "ч",
  ć: "ћ",
  ž: "ж",
  š: "ш",
  đ: "ђ",

  // special cases
  nj: "њ",
  lj: "љ",
  dž: "џ",
};

export const LATIN_CYRILIC_MAP = {
  ...LATIN_CYRILIC_MAP_LOWERCASE,
  ...LATIN_CYRILIC_MAP_UPPERCASE,
};

export const CYRILIC_LATIN_MAP = {
  ...CYRILIC_LATIN_MAP_LOWERCASE,
  ...CYRILIC_LATIN_MAP_UPPERCASE,
};

export const textConvert = (text: string, type: TranslationType): string => {
  let newText = "";

  const keyMap = type === "lat-cir" ? LATIN_CYRILIC_MAP : CYRILIC_LATIN_MAP;

  // we dont want to translate {{ text }} because its a i18n argument
  const interpolationStart = text.indexOf("{{");
  const interpolationEnd = text.indexOf("}}");
  const hasInterpolation = interpolationStart >= 0 && interpolationEnd >= 0;

  for (let i = 0; i < text.length; i++) {
    const currentCharacter = text[i];
    if (hasInterpolation && i >= interpolationStart && i <= interpolationEnd) {
      newText = newText + currentCharacter;
      continue;
    }
    const specialCharTest = currentCharacter + text[i + 1];
    const specialCharMapValue = keyMap[specialCharTest];
    if (specialCharMapValue) {
      newText = newText + specialCharMapValue;
      i = i + 1; // skip the next character, beauty of js
    } else {
      newText = newText + (keyMap[currentCharacter] || currentCharacter);
    }
  }

  return newText;
};

export const recursiveConvertor = (
  textObject: ILatinObject,
  type: TranslationType
): any => {
  const objKeys = Object.keys(textObject); // getKeys
  return objKeys.reduce((acc, key) => {
    return typeof textObject[key] === "string" // if string convert to selected type
      ? { ...acc, [key]: textConvert(textObject[key] as string, type) }
      : {
          // otherwise repeat one level deeper
          ...acc,
          //@ts-ignore
          [key]: recursiveConvertor(textObject[key], type),
        };
  }, {});
};

// Dont type localization text in uppercase,
// beacause currently output of Њ, Љ, Џ is Nj, Lj, Dž
// instead use .toUppercase() on translated value :)
// Hopefully soon we can fix it with some smart analitics
// like check if entire word is uppercase then ok Њ can be NJ.
// But we will see what is the best method
